import usePortalModal from 'hooks/usePortalModal';
import { functionUtils } from 'utils';
import CustomCameraMaskToCapturePhotoPopup from './popup';

const CustomCameraMaskToCapturePhotoModal = ({
  isShow,
  action,
  actionClose,
  modalData,
}) => {
  const { closePortalModalName } = usePortalModal();

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    closePortalModalName();
  };

  return (
    <CustomCameraMaskToCapturePhotoPopup
      isOpen={isShow}
      onClose={handleOnClose}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1068}
      zIndexModal={1069}
      modalData={modalData}
    />
  );
};

export default CustomCameraMaskToCapturePhotoModal;
